import React from "react";
import { useLocalizedStrings } from "../Localization"; 

const Hello = () => {
  const strings = useLocalizedStrings(); 

  return (
    <div className="flex justify-center items-center h-[300px]">
      <div className="md:w-[80%] w-[90%] border-4 border-black rounded-xl shadow-xl bg-[#FFDCCC] p-6 relative">
        <h2 className="text-center text-2xl font-bold">{strings.hello}</h2>
        <p className="text-center font-semibold">{strings.myNameIs}</p>
        <div className="m-auto border-4 border-black rounded-xl bg-[#f5f4ec] mt-4 md:p-6 lg:text-7xl lg:font-semibold p-1 text-3xl font-semibold text-center">
          {strings.fullName} 
        </div>
      </div>
    </div>
  );
};

export default Hello;
